module.exports = __webpack_public_path__ + "static/home-illustration-431d21e2052bf591b1fb785069674771.svg";